type LogLevel = "info" | "error" | "warn"

export type LogPayload = {
  level: LogLevel;
  message: string;
  timestamp: string;
}

const isServer = typeof window === "undefined";

function generateLogPayload(level: LogLevel, ...messages: any[]): LogPayload {
  return {
    level,
    message: messages.map(arg => 
      arg instanceof Error ? JSON.stringify({
        message: arg.message,
        stack: arg.stack
      }) : typeof arg === 'object' ? JSON.stringify(arg) : arg
    ).join(' '),
    timestamp: new Date().toISOString(),
  };
}

function generateLog(level: LogLevel, ...messages: any[]): string {
  return JSON.stringify(generateLogPayload(level, ...messages));
}

async function logUsingApi(payload: LogPayload) {
  try {
    await fetch("/api/logging", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });
  } catch (error) {
    console.error("Failed to send log to server:", error);
  }
};

const serverLoggerFunctions = {
  info: (...messages: any[]) => console.log(generateLog("info", ...messages)),
  error: (...messages: any[]) => console.error(generateLog("error", ...messages)),
  warn: (...messages: any[]) => console.warn(generateLog("warn", ...messages)),
};

const clientLoggerFunctions = {
  info: async (...messages: any[]) => await logUsingApi(generateLogPayload("info", ...messages)),
  error: async (...messages: any[]) => await logUsingApi(generateLogPayload("error", ...messages)),
  warn: async (...messages: any[]) => await logUsingApi(generateLogPayload("warn", ...messages)),
}

export const serverLogger = isServer ? serverLoggerFunctions : clientLoggerFunctions;